/**
 * News
 *
 */
const News = {
  postType: "article",
  currentPage: 1,

  init: () => {
    // check page
    const isArchive = document.querySelector("body.post-type-archive-article");
    if (!isArchive) return;

    // get load more btn
    const loadMoreButton = document.getElementById(
      "archive-news__btn-load-more",
    );

    if (!loadMoreButton) return;

    // setup load more btn event
    loadMoreButton.addEventListener("click", function (e) {
      e.preventDefault();
      News.currentPage++;
      News.ajaxRequest(false); // get posts
    });
  },

  // show/hide loadMoreButton
  showBtn: (show) => {
    const loadMoreButton = document.getElementById(
      "archive-news__btn-load-more",
    );

    if (loadMoreButton) {
      if (show) {
        loadMoreButton.classList.add("archive__btn-load-more--is-visible");
      } else {
        loadMoreButton.classList.remove("archive__btn-load-more--is-visible");
      }
    }
  },

  // loading toggle
  isLoading: (loading) => {
    console.log("isLoading: " + loading);
    const archiveBody = document.querySelector(".archive__body");

    if (archiveBody) {
      if (loading) {
        archiveBody.classList.add("archive__body--is-loading");
      } else {
        archiveBody.classList.remove("archive__body--is-loading");
      }
    }
  },

  // fetch posts
  ajaxRequest: function (overrideResult) {
    const $ = jQuery;
    const resultsBox = document.getElementById("results");
    if (!resultsBox) return;

    $.ajax({
      type: "post",
      dataType: "json",
      url: siteData.ajaxUrl,
      data: {
        action: "netzero_load_news",
        security: siteData.nonce,
        paged: News.currentPage,
        post_type: News.postType,
      },

      beforeSend: function () {
        News.isLoading(true);
        News.showBtn(false);
      },

      success: function (res) {
        console.log("Found: " + res.total);

        // check if last page
        if (News.currentPage >= res.max) {
          News.showBtn(false);
        } else {
          News.showBtn(true);
        }

        // render result
        if (overrideResult) {
          resultsBox.innerHTML = res.html;
        } else {
          // append posts
          resultsBox.insertAdjacentHTML("beforeend", res.html);
        }
      },

      error: function (xhr, status, error) {
        News.isLoading(false);
        News.showBtn(true);

        console.log(xhr);
        console.log(status);
        console.log(error);
      },

      complete: function () {
        News.isLoading(false);
      },
    });

    return false;
  },
};

export default News;
